import Vue from 'vue'
import VueRouter from 'vue-router'
import Jiechi from "@/views/Jiechi";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import("@/views/HomeView.vue"),
    },
    {
        path: '/course',
        name: 'course',
        component: () => import("@/views/CourseView.vue")
    },
    {
        path: '/level',
        name: 'level',
        component: () => import("@/views/LevelView.vue")
    },
    {
        path: '/authorization',
        name: 'authorization',
        component: () => import("@/views/AuthorizationView.vue")
    },
    {
        path: '/service',
        name: 'service',
        component: () => import("@/views/ServiceView.vue")
    },
    {
        path: '/business',
        name: 'business',
        component: () => import("@/views/BusinessView.vue")
    },
    {
        path: '/document',
        name: 'document',
        component: () => import("@/views/DocumentView.vue")
    },
    {
        path: '/article/:id',
        name: 'article',
        component: () => import("@/views/ArticleView.vue")
    },
    {
        path: '/MergerServerQuery',
        name: 'MergerServerQuery',
        component: () => import("@/views/MergerServerQuery.vue"),
    },
    {
        path: "/jc",
        name: "Jiechi",
        component: () => import("@/views/Jiechi.vue"),
    },
    {
        path: '/userCenter',
        component: () => import("@/views/UserCenter/LayoutView.vue"),
        children: [
            {
                path: '/',
                name: 'userCenter',
                component: () => import("@/views/UserCenter/HomeView.vue"),
            },
            {
                path: 'promote',
                name: 'promote',
                component: () => import("@/views/UserCenter/PromoteView.vue"),
            },
            {
                path: 'pay',
                name: 'pay',
                component: () => import("@/views/UserCenter/PayView.vue"),
            },
            {
                path: 'exchange',
                name: 'exchange',
                component: () => import("@/views/UserCenter/ExchangeView.vue"),
            },
            {
                path: 'cdKey',
                name: 'cdKey',
                component: () => import("@/views/UserCenter/CdKeyView.vue"),
            },
            {
                path: 'crazyFriday',
                name: 'crazyFriday',
                component: () => import("@/views/UserCenter/CrazyFridayView.vue"),
            },
            // {
            //     path: 'gameTransfer',
            //     name: 'gameTransfer',
            //     component: () => import("@/views/UserCenter/GameTransferView.vue"),
            // },
            {
                path: 'roleTransfer',
                name: 'roleTransfer',
                component: () => import("@/views/UserCenter/RoleTransferView.vue"),
            },
            {
                path: 'onlyServer',
                name: 'onlyServer',
                component: () => import("@/views/UserCenter/OnlyServerView.vue"),
            },
            {
                path: 'bindMobile',
                name: 'bindMobile',
                component: () => import("@/views/UserCenter/BindMobileView.vue"),
            },
            {
                path: 'bindIdCard',
                name: 'bindIdCard',
                component: () => import("@/views/UserCenter/BindIdCardView.vue"),
            },
            {
                path: 'log',
                name: 'log',
                component: () => import("@/views/UserCenter/LogView.vue"),
            },
            {
                path: 'merge',
                name: 'merge',
                component: () => import("@/views/UserCenter/MergeView.vue"),
            },
        ]
    },
    {
        path: '/activity',
        component: () => import("@/views/Activity/Layout.vue"),
        children: [
            {
                path: 'month',
                name: 'month',
                component: () => import("@/views/Activity/Month.vue"),
            },
            {
                path: 'redEnvelope',
                name: 'redEnvelope',
                component: () => import("@/views/Activity/RedEnvelope/index.vue"),
            },
			{
			    path: 'memberDay',
			    name: 'memberDay',
			    component: () => import("@/views/Activity/MemberDay/index.vue"),
			}
        ]
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior: () => ({y: 0}),
    routes
})

export default router
